import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

export default function KYCSuccess({ baseUrl }) {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const clientUid = searchParams.get("client_uid");
        const customerUid = searchParams.get("customer_uid");
        const amount = searchParams.get("amount");

        if (clientUid && customerUid && amount) {
            var formData = new FormData();
            formData.append("client_uid", clientUid);
            formData.append("customer_uid", customerUid);
            formData.append("amount", amount);

            axios.post(baseUrl + "/wallet-kyc-success", formData)
                .then(res => {
                    console.log("Stripe confirm:", res.data);

                })
                .catch(err => {
                    console.error("Stripe confirm error:", err);
                    Swal.fire({
                        icon: "error",
                        title: "Feil",
                        text: "Noe gikk galt med betalingen. Vennligst prøv igjen.",
                    });
                });
        }
    }, [searchParams]);

    return (
        <div className="p-6 text-center">
            <h1 className="text-xl font-bold">Bekrefter betaling...</h1>
            <p>Vennligst vent et øyeblikk.</p>
        </div>
    );
}
